module.exports = __webpack_public_path__ + "static/media/park.542ddf01.png";